const ayudaInitialState = {
  ayuda: {
    show: true,
  },
};

export default ayudaInitialState;
